export default "__VITE_ASSET__Oro3QN1r__"